import React, { useState } from 'react';
import { ShieldCheckIcon, CreditCardIcon, TruckIcon, LockIcon } from 'lucide-react';
import { PolicyModal } from './PolicyModal';
export function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    content: <></>
  });
  const openModal = (title: string, content: React.ReactNode) => {
    setModalContent({
      title,
      content
    });
    setIsModalOpen(true);
  };
  const privacyPolicy = <div className="space-y-4 text-stone-700" data-id="element-172">
      <p data-id="element-173">
        <strong data-id="element-174">Effective Date:</strong> October 15, 2025
      </p>
      <p data-id="element-175">
        At Voices of Freedom, we respect your privacy and are committed to
        protecting your personal data. This Privacy Policy explains how we
        collect, use, and safeguard your information when you visit our website
        or purchase our products.
      </p>
      <h3 className="text-lg font-bold mt-4" data-id="element-176">Information We Collect</h3>
      <p data-id="element-177">
        We collect information that you provide directly to us, such as when you
        make a purchase, sign up for our newsletter, or contact us. This may
        include:
      </p>
      <ul className="list-disc pl-5" data-id="element-178">
        <li data-id="element-179">
          Contact information (name, email address, mailing address, phone
          number)
        </li>
        <li data-id="element-180">Payment information (credit card details, billing address)</li>
        <li data-id="element-181">Order information (products purchased, order history)</li>
        <li data-id="element-182">Communications you send to us</li>
      </ul>
      <h3 className="text-lg font-bold mt-4" data-id="element-183">How We Use Your Information</h3>
      <p data-id="element-184">We use your information to:</p>
      <ul className="list-disc pl-5" data-id="element-185">
        <li data-id="element-186">Process and fulfill your orders</li>
        <li data-id="element-187">Communicate with you about your orders</li>
        <li data-id="element-188">Send you marketing communications (if you've opted in)</li>
        <li data-id="element-189">Improve our website and services</li>
        <li data-id="element-190">Comply with legal obligations</li>
      </ul>
      <h3 className="text-lg font-bold mt-4" data-id="element-191">Information Sharing</h3>
      <p data-id="element-192">
        We do not sell your personal information. We may share your information
        with:
      </p>
      <ul className="list-disc pl-5" data-id="element-193">
        <li data-id="element-194">Service providers who help us operate our business</li>
        <li data-id="element-195">Legal authorities when required by law</li>
      </ul>
      <h3 className="text-lg font-bold mt-4" data-id="element-196">Your Rights</h3>
      <p data-id="element-197">
        Depending on your location, you may have certain rights regarding your
        personal data, including:
      </p>
      <ul className="list-disc pl-5" data-id="element-198">
        <li data-id="element-199">Access to your personal data</li>
        <li data-id="element-200">Correction of inaccurate data</li>
        <li data-id="element-201">Deletion of your data</li>
        <li data-id="element-202">Objection to certain processing</li>
      </ul>
      <p data-id="element-203">
        For any privacy-related questions, please contact us at
        voicesoffreedomus@gmail.com.
      </p>
    </div>;
  const termsOfService = <div className="space-y-4 text-stone-700" data-id="element-204">
      <p data-id="element-205">
        <strong data-id="element-206">Effective Date:</strong> October 15, 2025
      </p>
      <p data-id="element-207">
        Welcome to Voices of Freedom. By accessing or using our website, you
        agree to be bound by these Terms of Service.
      </p>
      <h3 className="text-lg font-bold mt-4" data-id="element-208">Use of Our Website</h3>
      <p data-id="element-209">You may use our website for lawful purposes only. You agree not to:</p>
      <ul className="list-disc pl-5" data-id="element-210">
        <li data-id="element-211">Use our website in any way that violates applicable laws</li>
        <li data-id="element-212">Attempt to gain unauthorized access to any part of our website</li>
        <li data-id="element-213">Use our website to transmit malicious code</li>
        <li data-id="element-214">Collect user information without consent</li>
      </ul>
      <h3 className="text-lg font-bold mt-4" data-id="element-215">Intellectual Property</h3>
      <p data-id="element-216">
        All content on this website, including text, graphics, logos, and
        images, is the property of Voices of Freedom and is protected by
        copyright laws. You may not reproduce, distribute, or create derivative
        works without our express consent.
      </p>
      <h3 className="text-lg font-bold mt-4" data-id="element-217">Product Information</h3>
      <p data-id="element-218">
        We strive to provide accurate product information, but we do not warrant
        that product descriptions or other content is accurate, complete, or
        error-free. Prices are subject to change without notice.
      </p>
      <h3 className="text-lg font-bold mt-4" data-id="element-219">Limitation of Liability</h3>
      <p data-id="element-220">
        Voices of Freedom shall not be liable for any direct, indirect,
        incidental, special, or consequential damages resulting from the use or
        inability to use our products or services.
      </p>
      <h3 className="text-lg font-bold mt-4" data-id="element-221">Governing Law</h3>
      <p data-id="element-222">
        These Terms shall be governed by and construed in accordance with the
        laws of the United States, without regard to its conflict of law
        provisions.
      </p>
      <p data-id="element-223">
        For any questions regarding these Terms, please contact us at
        voicesoffreedomus@gmail.com.
      </p>
    </div>;
  const returnPolicy = <div className="space-y-4 text-stone-700" data-id="element-224">
      <p data-id="element-225">
        <strong data-id="element-226">Effective Date:</strong> October 15, 2025
      </p>
      <h3 className="text-lg font-bold" data-id="element-227">
        7-Day Return Policy for Printed Books
      </h3>
      <p data-id="element-228">
        We stand behind the quality of our printed books and want you to be
        completely satisfied with your purchase.
      </p>
      <h3 className="text-lg font-bold mt-4" data-id="element-229">Return Eligibility</h3>
      <p data-id="element-230">
        You may return printed books purchased from Voices of Freedom within 7
        days of delivery if:
      </p>
      <ul className="list-disc pl-5" data-id="element-231">
        <li data-id="element-232">The book arrives damaged or defective</li>
        <li data-id="element-233">You receive the wrong book</li>
        <li data-id="element-234">You are dissatisfied with the quality of the book</li>
      </ul>
      <h3 className="text-lg font-bold mt-4" data-id="element-235">Return Process</h3>
      <ol className="list-decimal pl-5" data-id="element-236">
        <li data-id="element-237">
          Contact us at voicesoffreedomus@gmail.com within 7 days of receiving
          your order
        </li>
        <li data-id="element-238">Include your order number and reason for return</li>
        <li data-id="element-239">We'll provide a return shipping address and instructions</li>
        <li data-id="element-240">Ship the book back in its original condition</li>
        <li data-id="element-241">
          Once we receive and inspect the return, we'll process your refund
        </li>
      </ol>
      <h3 className="text-lg font-bold mt-4" data-id="element-242">Refunds</h3>
      <p data-id="element-243">
        Refunds will be issued to the original payment method within 14 business
        days after we receive the returned item. Shipping costs are
        non-refundable unless the return is due to our error.
      </p>
      <h3 className="text-lg font-bold mt-4" data-id="element-244">Non-Returnable Items</h3>
      <p data-id="element-245">
        Digital products, including e-books and digital downloads, are
        non-returnable and non-refundable once the order is complete.
      </p>
      <p data-id="element-246">
        For any questions about returns, please contact us at
        voicesoffreedomus@gmail.com.
      </p>
    </div>;
  const contactInfo = <div className="space-y-4 text-stone-700" data-id="element-247">
      <h3 className="text-lg font-bold" data-id="element-248">Contact Us</h3>
      <p data-id="element-249">
        We're here to help! If you have any questions, concerns, or feedback,
        please don't hesitate to reach out.
      </p>
      <div className="mt-4" data-id="element-250">
        <p data-id="element-251">
          <strong data-id="element-252">Email:</strong>{' '}
          <a href="mailto:voicesoffreedomus@gmail.com" className="text-amber-600 hover:text-amber-500" data-id="element-253">
            voicesoffreedomus@gmail.com
          </a>
        </p>
        <p className="mt-2" data-id="element-254">
          <strong data-id="element-255">Response Time:</strong> We strive to respond to all inquiries
          within 24-48 business hours.
        </p>
      </div>
      <div className="mt-6" data-id="element-256">
        <h4 className="font-medium" data-id="element-257">For questions about:</h4>
        <ul className="list-disc pl-5 mt-2" data-id="element-258">
          <li data-id="element-259">Order status or shipping information</li>
          <li data-id="element-260">Product details or availability</li>
          <li data-id="element-261">Returns or exchanges</li>
          <li data-id="element-262">Website functionality</li>
          <li data-id="element-263">Partnership opportunities</li>
        </ul>
      </div>
      <form className="mt-6 space-y-4" data-id="element-264">
        <div data-id="element-265">
          <label htmlFor="name" className="block text-sm font-medium text-stone-700" data-id="element-266">
            Name
          </label>
          <input type="text" id="name" className="mt-1 block w-full px-3 py-2 border border-stone-300 rounded-md shadow-sm focus:outline-none focus:ring-amber-500 focus:border-amber-500" data-id="element-267" />
        </div>
        <div data-id="element-268">
          <label htmlFor="email" className="block text-sm font-medium text-stone-700" data-id="element-269">
            Email
          </label>
          <input type="email" id="email" className="mt-1 block w-full px-3 py-2 border border-stone-300 rounded-md shadow-sm focus:outline-none focus:ring-amber-500 focus:border-amber-500" data-id="element-270" />
        </div>
        <div data-id="element-271">
          <label htmlFor="message" className="block text-sm font-medium text-stone-700" data-id="element-272">
            Message
          </label>
          <textarea id="message" rows={4} className="mt-1 block w-full px-3 py-2 border border-stone-300 rounded-md shadow-sm focus:outline-none focus:ring-amber-500 focus:border-amber-500" data-id="element-273"></textarea>
        </div>
        <button type="button" className="bg-amber-600 hover:bg-amber-500 text-white font-medium py-2 px-4 rounded-md transition duration-300" data-id="element-274">
          Send Message
        </button>
      </form>
    </div>;
  return <footer className="bg-stone-100 border-t border-stone-200 pt-10 pb-6 text-stone-700" data-id="element-275">
      <div className="max-w-6xl mx-auto px-6" data-id="element-276">
        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-8 mb-10" data-id="element-277">
          <div className="flex flex-col items-center text-center max-w-[150px]" data-id="element-278">
            <div className="bg-stone-50 p-3 rounded-full shadow-sm border border-stone-200 mb-2" data-id="element-279">
              <ShieldCheckIcon className="w-10 h-10 text-amber-600" data-id="element-280" />
            </div>
            <span className="text-sm font-medium" data-id="element-281">100% Secure Checkout</span>
          </div>
          <div className="flex flex-col items-center text-center max-w-[150px]" data-id="element-282">
            <div className="bg-stone-50 p-3 rounded-full shadow-sm border border-stone-200 mb-2" data-id="element-283">
              <CreditCardIcon className="w-10 h-10 text-amber-600" data-id="element-284" />
            </div>
            <span className="text-sm font-medium" data-id="element-285">SSL Encrypted Payment</span>
          </div>
          
          
        </div>
        {/* Payment Methods */}
        
        <div className="border-t border-stone-200 pt-6" data-id="element-286">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 mb-6 text-sm" data-id="element-287">
            <button onClick={() => openModal('Privacy Policy', privacyPolicy)} className="text-stone-600 hover:text-amber-600 transition-colors" data-id="element-288">
              Privacy Policy
            </button>
            <button onClick={() => openModal('Terms of Service', termsOfService)} className="text-stone-600 hover:text-amber-600 transition-colors" data-id="element-289">
              Terms of Service
            </button>
            <button onClick={() => openModal('Return Policy', returnPolicy)} className="text-stone-600 hover:text-amber-600 transition-colors" data-id="element-290">
              7-Day Return Policy
            </button>
            <button onClick={() => openModal('Contact Us', contactInfo)} className="text-stone-600 hover:text-amber-600 transition-colors" data-id="element-291">
              Contact Us
            </button>
          </div>
          <div className="text-center text-stone-500 text-sm" data-id="element-292">
            <p data-id="element-293">
              &copy; {new Date().getFullYear()} Voices of Freedom. All rights
              reserved.
            </p>
            <p className="mt-1" data-id="element-294">Inspiring a new generation of patriots.</p>
          </div>
        </div>
      </div>
      <PolicyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={modalContent.title} content={modalContent.content} data-id="element-295" />
    </footer>;
}